import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { getReportsLayoutData } from "#/modules/rapporten/rapporten.functions";

export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/reports")({
  loader: () => getReportsLayoutData(),
  component: ReportsLayout,
  errorComponent: ReportsError,
});

function ReportsLayout() {
  return <Outlet />;
}

function ReportsError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
